export default __webpack_public_path__ + "07516441f49217fd0fac60a0a2f9507f.woff";